import { PathOptions } from "leaflet";

export const lts_neoenergia = (feature: any): PathOptions => {
  const tensao = feature?.properties?.tensao_kv;
  return {
    color: tensao === 138 ? "rgba(249, 170, 40, 1)" : "#d78cff",
    weight: 2,
    opacity: 0.8,
  };
};
